export const REQUEST_BOOKLIST = "REQUEST_BOOKLIST";
export const REQUEST_BOOKLIST_SUCCESS = "REQUEST_BOOKLIST_SUCCESS";
export const REQUEST_BOOKLIST_FAIL = "REQUEST_BOOKLIST_FAIL";
export const ADD_BOOK = "ADD_BOOK";
export const EDIT_BOOK = "EDIT_BOOK";
export const DELETE_BOOK = "DELETE_BOOK";
